import { Pill } from "@mixitone/components";
import { fundingOutreachStatusLabel, fundingOutreachStatusPillColor } from "lib/fundingStatusLabels";

export function FundingOutreachStatusPill({ status }: { status: string | null | undefined }) {
  const value = status ?? "";
  return <Pill color={fundingOutreachStatusPillColor(value)}>{fundingOutreachStatusLabel(value)}</Pill>;
}
